'use client'

import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { useProofKyc } from '@/hooks/kalshi/useProofKyc'
import { useWallet } from '@/providers/WalletContext'
import { useModalStore } from '@/stores/modal-store'
import { Loader2 } from 'lucide-react'
import { useTranslations } from 'next-intl'

export function KycVerificationModal() {
	const t = useTranslations('kyc')
	const { activeModal, closeModal, openModal } = useModalStore()
	const { solanaAddress } = useWallet()
	const { startVerification, isRedirecting } = useProofKyc(solanaAddress)
	const isOpen = activeModal === 'kyc-verification'

	return (
		<Dialog open={isOpen} onOpenChange={open => !open && closeModal()}>
			<DialogContent className="border-white/10 bg-brand-dark sm:max-w-md">
				<DialogHeader className="items-center text-center">
					<DialogTitle className="text-white text-xl">{t('verificationRequired')}</DialogTitle>
					<DialogDescription className="text-white/60">
						{t('verificationDescription')}
					</DialogDescription>
				</DialogHeader>
				<div className="flex flex-col gap-3">
					<Button
						onClick={() => {
							closeModal()
							openModal('bridge')
						}}
						className="w-full bg-brand-blue text-white hover:bg-brand-blue/90"
					>
						{t('bridgeToPolymarket')}
					</Button>
					<div className="text-center text-sm text-white/40">{t('orVerify')}</div>
					<Button
						onClick={startVerification}
						disabled={isRedirecting}
						variant="outline"
						className="w-full border-white/10 text-white hover:bg-white/5"
					>
						{isRedirecting ? (
							<>
								<Loader2 className="mr-2 h-4 w-4 animate-spin" />
								{t('verifying')}
							</>
						) : (
							t('verifyNow')
						)}
					</Button>
					<Button
						onClick={closeModal}
						variant="ghost"
						className="w-full text-white/60 hover:text-white"
					>
						{t('cancel')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
